// Apis
import { PiUserUpdateRequestDataType, updateUserProfile } from 'Shared/api/PiUser.api';
// Hooks
import { useCurrentUser } from './use-current-user';
import { useApp } from './use-app';

export const useUpdateUserProfile = () => {
  const { app } = useApp();
  const { user } = useCurrentUser();

  const transformUserProfileToPost = (
    updatedFirstName: string,
    updatedLastName: string
  ): PiUserUpdateRequestDataType => {
    return {
      firstName: updatedFirstName,
      lastName: updatedLastName,
      userEmail: user.email,
      userGuid: user.piUserGuid,
    };
  };

  /**
   * Update Users first name & last name on PI [User & SurveyUser Table] and Salesforce
   * @param updatedFirstName
   * @param updatedLastName
   */
  const updateUserInfo = async (updatedFirstName: string, updatedLastName: string) => {
    const payload = transformUserProfileToPost(updatedFirstName, updatedLastName);
    await updateUserProfile({ companyGuid: app.inviter.organization.piCompanyGuid, data: payload });
  };

  return {
    updateUserInfo,
  };
};
